import React from "react";
import BrunelloHeader from "../components/BrunelloCucinelli/BrunelloHeader"

const brunello = {
    favicon: "/assets/bc-favicon.ico",
    logo: "/assets/bc-logo.png",
    tagUrl: "//pf-track.inside-graph.com/gtm/IN-1000953/include.js",
    customHeader: () => <BrunelloHeader />,
    customCss: () => {
        var cssLink = document.createElement("link");
        cssLink.href = "//fonts.googleapis.com/css?family=Lora:400,700&display=swap";
        cssLink.rel = "stylesheet";
        cssLink.type = "text/css";
        document.head.appendChild(cssLink);

        var css = "body {font-family: Lora, 'Nunito Sans', sans-serif} .subheader .status {margin-right: 15px}";
        var style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    },
    customFrameCss: () => {
        var interval = setInterval(() => {
            if (window.frames.length < 2) {
                return;
            }
            var cssLink = document.createElement("link");
            cssLink.href = "//fonts.googleapis.com/css?family=Lora:400,700&display=swap";
            cssLink.rel = "stylesheet";
            cssLink.type = "text/css";
            window.frames[1].document.head.appendChild(cssLink);
            clearInterval(interval);

            var frameCss = "#inside_video_streamlistContainer, #inside_video_streamlistContainer * {font-family: Lora, 'Nunito Sans', sans-serif} h1 {display: none} div#inside_video_streamlist {padding: 0 20px} .inside_video_stream.scheduled {cursor: default} .inside_video_stream.scheduled .inside_video_stream_starttime {top: 248px} .inside_video_stream.scheduled .inside_video_stream_button {display: none}";
            var frameStyle = window.frames[1].document.createElement("style");
            frameStyle.appendChild(document.createTextNode(frameCss));
            window.frames[1].document.head.appendChild(frameStyle);
        }, 200);
    }
}

export default brunello;